import { gql } from '@apollo/client';
import { achievementFragment } from '../fragments/achievement';

export const getLatestAchievements = gql`
    ${achievementFragment}

    query GetLatestAchievements($limit: Float, $orderBy: String) {
        achievements(limit: $limit, orderBy: $orderBy) {
            ...AchievementFields
        }
    }
`;

export const getCategoryAchievements = gql`
    ${achievementFragment}

    query GetCategoryAchievements($categoryId: String!) {
        achievements(categoryId: $categoryId) {
            ...AchievementFields
        }
    }
`;
